import { createSelector } from 'reselect';
import { returnJS } from 'utils/helpers';
import { initialState } from './reducer';

const selectReferrerSignUpDomain = (state) => state.get('referrerSignUp', initialState);

const makeSelectLoading = () =>
	createSelector(selectReferrerSignUpDomain, (substate) =>
		returnJS(substate.get('loading')));

const makeSelectError = () =>
	createSelector(selectReferrerSignUpDomain, (substate) =>
		returnJS(substate.get('error')));

const makeSelectSuccess = () =>
	createSelector(selectReferrerSignUpDomain, (substate) =>
		returnJS(substate.get('success')));

export { makeSelectLoading, makeSelectError, makeSelectSuccess };
